import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fromCartProductIngredientsArray'
})
export class FromCartProductIngredientsArrayPipe implements PipeTransform {
  transform(collection: any[]): string {
    const selectedIngredients = [];

    collection?.map((ingredient) => {
      selectedIngredients.push(ingredient);
    });
    return selectedIngredients.map((x) => '- ' + x.name.trim()).join(', ');
  }
}
